// extracted by mini-css-extract-plugin
export var button = "UnsavedChangesModal-module__button___tfDTJ";
export var buttonRow = "UnsavedChangesModal-module__buttonRow___NXcWf";
export var description = "UnsavedChangesModal-module__description___VDsu+";
export var modalBody = "UnsavedChangesModal-module__modalBody___6Ib2G";
export var title = "UnsavedChangesModal-module__title___XTvtb";